import { usePermissionChecker } from 'hooks/usePermissionChecker';
import { useRequireParams } from 'hooks/useRequireParams';
import { BpSubpage } from '../../../components/BpSubpage/BpSubpage';
import { useAuthClaims } from '../../../hooks/useAuthClaims';
import { CourseAssignmentsStudentContent } from './StudentContent/CourseAssignmentsStudentContent';
import { CourseAssignmentsTeacherContent } from './TeacherContent/CourseAssignmentsTeacherContent';

export const CourseAssignmentsSubpage = () => {
  const { pimAuthClaims } = useAuthClaims();
  const { courseUuid } = useRequireParams(['courseUuid']);

  const permissions = usePermissionChecker();

  return (
    <BpSubpage>
      {permissions?.canCreateAssignment({
        uuid: courseUuid,
        organization: { uuid: pimAuthClaims.getOrganizationUuid() },
      }) ? (
        <CourseAssignmentsTeacherContent />
      ) : (
        <CourseAssignmentsStudentContent />
      )}
    </BpSubpage>
  );
};
